import { foldUwContexts, LegacyUwQuestionnaire, MigratedProductUw } from '@ps20-frontend/migrations';
import {
  LegacyWarenkorbUwFragebogen,
  StatePreV18,
  StateV18,
  WarenkorbAngebotPreV18,
  WarenkorbAngebotV18,
} from './18_migrate_uw_contexts.interface';

const toLegacyQuestionnaire = (
  fragebogen: LegacyWarenkorbUwFragebogen | undefined,
): LegacyUwQuestionnaire | undefined => {
  if (!fragebogen) {
    return undefined;
  }
  return {
    files: fragebogen.files ?? [],
    beschreibung: fragebogen.beschreibung,
    comment: fragebogen.comment,
    uwDecision: fragebogen.uwDecision,
    underwriterName: fragebogen.underwriterName,
    underwriterBensl: fragebogen.underwriterBensl,
  };
};

const migrateWarenkorbAngebot = (angebot: WarenkorbAngebotPreV18): WarenkorbAngebotV18 => {
  const {
    elementarfragebogen,
    nebengebaeude,
    showElementarfragebogen,
    showNebengebaeude,
    isUnderwriterInfoVisible,
    ...rest
  } = angebot;

  const uw: MigratedProductUw | undefined = foldUwContexts({
    uw: angebot.uw,
    naturalHazards: toLegacyQuestionnaire(elementarfragebogen),
    outbuilding: toLegacyQuestionnaire(nebengebaeude),
    isUnderwriterInfoVisible,
    showElementarfragebogen,
    showNebengebaeude,
  });

  return uw ? { ...rest, uw } : { ...rest };
};

export const migrateWarenkorbUwContexts = (
  previousState: StatePreV18,
  newVersion: number,
): StateV18 =>
  ({
    ...previousState,
    version: newVersion,
    warenkorb: previousState.warenkorb.map(migrateWarenkorbAngebot),
  }) as StateV18;
